import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  text: {
    marginVertical: 16,
  },
  toogleContainer: theme => ({
    justifyContent: 'center',
    alignItems: 'center',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorThree,
  }),
  toggleText: {
    paddingVertical: 12,
  },
})
